import { createContext, useContext, useEffect, useState } from "react";

const ProjectContext = createContext({
  project: null,
  project_id: "",
  isProjectReady: false,
  selectProject: () => {},
  clearProject: () => {},
});

export const ProjectProvider = ({ children }) => {
  const [project, setProject] = useState(null);
  const [isProjectReady, setIsProjectReady] = useState(false);

  // ✅ Restore project on load (safe)
  useEffect(() => {
    if (typeof window === "undefined") return;

    try {
      const stored = localStorage.getItem("selected_project");
      setProject(stored ? JSON.parse(stored) : null);
    } catch (err) {
      console.error("Invalid selected_project in localStorage", err);
      setProject(null);
    } finally {
      // ✅ Mark context ready
      setIsProjectReady(true);
    }
  }, []);

  // ✅ Sync whenever project changes
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!isProjectReady) return; // ✅ don't sync before load finished

    if (project) {
      localStorage.setItem("selected_project", JSON.stringify(project));
    } else {
      localStorage.removeItem("selected_project");
    }
  }, [project, isProjectReady]);

  const selectProject = (newProject) => setProject(newProject);
  const clearProject = () => setProject(null);

  return (
    <ProjectContext.Provider
      value={{
        project,
        project_id: project?.project_id ?? "",
        isProjectReady,
        selectProject,
        clearProject,
      }}
    >
      {children}
    </ProjectContext.Provider>
  );
};

export const useProject = () => useContext(ProjectContext);
